<em-main>
  <div class="header">
    <h2 i18n>Recherche rapport de vente</h2>
  </div>

  @if (tableEntries) {
    <p-card class="p-card container">
      <p-table
        [value]="tableEntries"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="true"
        [rowHover]="true"
        paginatorDropdownScrollHeight="160px"
        styleClass="sales-table"
        responsiveLayout="scroll"
        dataKey="id">
        <ng-template pTemplate="caption">
          <div class="table-section__header">
            <span i18n class="table-section__header--title">Liste des rapports de vente</span>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" [formControl]="filter" i18n-placeholder placeholder="Chercher" />
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr class="table-section__thead">
            <th pSortableColumn="policyNumber" i18n
              >Numéro de police
              <p-sortIcon field="policyNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="fullName" i18n
              >Nom complet
              <p-sortIcon field="fullName"></p-sortIcon>
            </th>
            <th pSortableColumn="insureeEmail" i18n
              >Courriel client
              <p-sortIcon field="insureeEmail"></p-sortIcon>
            </th>
            <th pSortableColumn="advisorEmail" i18n
              >Courriel conseiller
              <p-sortIcon field="advisorEmail"></p-sortIcon>
            </th>
            <th pSortableColumn="insurer" i18n
              >Assureur
              <p-sortIcon field="insurer"></p-sortIcon>
            </th>
            <th pSortableColumn="annualPremium" i18n
              >Prime annuelle
              <p-sortIcon field="annualPremium"></p-sortIcon>
            </th>
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-tableEntry>
          <tr class="status">
            <td>{{ tableEntry.policyNumber || '--' }}</td>
            <td>{{ tableEntry.fullName }}</td>
            <td>{{ tableEntry.insureeEmail }}</td>
            <td>{{ tableEntry.advisorEmail }}</td>
            <td>{{ tableEntry.insurer }}</td>
            <td>{{ tableEntry.annualPremium | emAmount }}</td>
            <td>
              <p-button
                class="progress-button"
                (onClick)="openSaleReport(tableEntry.id)"
                i18n-label
                label="Ouvrir"
                icon="pi pi-folder-open"
                iconPos="left"></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  }
</em-main>
